// apps/api/src/qxcircle/qxcircle-comment-action.ts
// Description: QXCircle comment/reply create + local notifications (Slice 18–23).
// Owner: Masa Bayu
// Date: 2026-08-24

import { isManagedQxCirclePost } from "./qxcircle-post-presenter";
import {
  createCommentNotification,
  createReplyNotification,
} from "./qxcircle-comment-notification";
import { createQxCircleCommentRecord } from "./qxcircle-comment-write";
import type {
  CreateQxCircleCommentInput,
  QxCircleComment,
  QxCircleFeedPost,
  QxCircleNotification,
} from "./qxcircle.types";

export function createQxCircleCommentWithNotification(
  post: QxCircleFeedPost,
  input: CreateQxCircleCommentInput,
  comments: QxCircleComment[],
  commentSeq: number,
  ntfSeq: number,
): {
  comment: QxCircleComment;
  nextCommentSeq: number;
  notifications: QxCircleNotification[];
  nextNotificationSeq: number;
} {
  const created = createQxCircleCommentRecord(post.id, input, comments, commentSeq);
  const notifications: QxCircleNotification[] = [];
  let nextNotificationSeq = ntfSeq;
  const parent = created.comment.parentId
    ? comments.find((c) => c.id === created.comment.parentId)
    : undefined;
  const actorId = input.ownerAccountId ?? null;

  if (parent && parent.ownerAccountId !== actorId) {
    nextNotificationSeq += 1;
    notifications.push(
      createReplyNotification(nextNotificationSeq, parent.authorName, post.id),
    );
  } else if (!parent && !isManagedQxCirclePost(post, actorId)) {
    nextNotificationSeq += 1;
    notifications.push(
      createCommentNotification(nextNotificationSeq, post.authorName, post.id),
    );
  }

  return {
    comment: created.comment,
    nextCommentSeq: created.nextSeq,
    notifications,
    nextNotificationSeq,
  };
}
